// extracted by mini-css-extract-plugin
export var audioPlayer = "_mw-0";